var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 11.5625,
    stroke: "#310048",
    strokeWidth: 1.875
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_946_23240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7914 18.038V20.2082H11.9615L18.362 13.8077L16.1919 11.6376L9.7914 18.038ZM20.0402 12.1294C20.2659 11.9038 20.2659 11.5392 20.0402 11.3135L18.6861 9.95931C18.4604 9.73362 18.0958 9.73362 17.8701 9.95931L16.8111 11.0183L18.9812 13.1885L20.0402 12.1294Z",
    fill: "#310048"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_946_23240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8889,
    height: 13.8889,
    fill: "white",
    transform: "translate(8.05556 8.05566)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalNote);
export default __webpack_public_path__ + "static/media/personal-note.3c58af3ad724241c37ea8f7fe46225d0.svg";
export { ForwardRef as ReactComponent };